<div class="rx-intuitive-implant-based-denture-modal">
	<tlk-modal-header>
		{{ 'UnitTypes.ImplantBased' | translate }}
		<button tlkButton variant="ghost" size="l" right-icon (click)="handleCancel()">
			<tlk-close-empty-icon class="tlk-icon_size_l" />
		</button>
	</tlk-modal-header>

	<tlk-modal-content>
		<div class="rx-intuitive-implant-based-denture-modal__diagram-strip">
			<rx-intuitive-mini-teeth-diagram [teeth]="teeth" [numberPosition]="'below'"></rx-intuitive-mini-teeth-diagram>
		</div>

		<form [formGroup]="manufactureForm" class="rx-intuitive-implant-based-denture-modal__manufacture-form">
			<rx-favorite-selector
				class="rx-intuitive-implant-based-denture-modal__manufacture-field"
				[id]="'intuitive-scan-body-manufacturer'"
				[label]="'ToothEditor.ScanBodyManufacturer' | translate"
				[isRequired]="shouldValidateForSend$ | async"
				[isCancellable]="(shouldValidateForSend$ | async) === false && isProcedureFlow"
				[formControl]="scanBodyManufacturerControl"
				[isReadOnly]="false"
				[options]="scanBodyManufacturerOptions$ | async"
				[favoriteName]="favoriteScanBody"
				name="scanBodyManufacturerControl"
				[enableSimpleMode]="isFavoritesHidden$ | async"
			></rx-favorite-selector>
			<rx-favorite-selector
				class="rx-intuitive-implant-based-denture-modal__manufacture-field"
				[id]="'intuitive-implant-manufacturer'"
				[label]="'ToothEditor.ImplantManufacturer' | translate"
				[isReadOnly]="false"
				[isRequired]="shouldValidateForSend$ | async"
				[isCancellable]="(shouldValidateForSend$ | async) === false && isProcedureFlow"
				[formControl]="implantManufacturerControl"
				[options]="implantManufacturerOptions"
				[isDisabled]="!implantManufacturerOptions?.length"
				[favoriteName]="favoriteImplant"
				name="implantManufacturerControl"
				[enableSimpleMode]="isFavoritesHidden$ | async"
			></rx-favorite-selector>
			<rx-select
				class="rx-intuitive-implant-based-denture-modal__manufacture-field"
				[id]="'intuitive-implant-type-scan-body'"
				[label]="'ToothEditor.ImplantTypeScanBody' | translate"
				[isDisabled]="!implantTypeScanBodyOptions?.length"
				[isRequired]="shouldValidateForSend$ | async"
				[isCancellable]="(shouldValidateForSend$ | async) === false && isProcedureFlow"
				[formControl]="implantTypeScanBodyControl"
				[options]="implantTypeScanBodyOptions"
				[dropdownPositions]="'right'"
				[panelClass]="'implant-type-scan-body-panel'"
			></rx-select>
		</form>
	</tlk-modal-content>

	<tlk-modal-footer>
		<ng-container ngProjectAs="[right-buttons]">
			<button tlkButton variant="primary" size="m" (click)="handleClose()">
				{{ 'Done' | translate }}
			</button>
		</ng-container>
	</tlk-modal-footer>
</div>
